﻿// @ts-nocheck
// data cleanup

// ========== Data Cleanup Functions ==========
async function scanAndShowCleanupSuggestions() {
  const scanDataBtn = document.getElementById("scanDataBtn");
  const cleanupMessage = document.getElementById("cleanupMessage");
  const cleanupStatus = document.getElementById("cleanupStatus");
  const cleanupStatusText = document.getElementById("cleanupStatusText");
  const cleanupSuggestions = document.getElementById("cleanupSuggestions");

  if (scanDataBtn) scanDataBtn.disabled = true;
  if (cleanupMessage) cleanupMessage.textContent = "Scanning...";

  try {
    const res = await fetchWithAuth("/api/cleanup-suggestions", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
    });

    if (!res.ok) throw new Error("Failed to scan data");

    const reader = res.body.getReader();
    const decoder = new TextDecoder();
    let responseText = "";

    while (true) {
      const { done, value } = await reader.read();
      if (done) break;
      const chunk = decoder.decode(value, { stream: true });
      const lines = chunk.split("\n");
      for (const line of lines) {
        if (!line.trim()) continue;
        try {
          const jsonData = JSON.parse(line);
          if (jsonData.response) {
            responseText += jsonData.response;
          }
        } catch (e) {
          // Ignore JSON parse errors
        }
      }
    }

    // Parse AI suggestions
    console.log("Cleanup response:", responseText);
    const jsonMatch = responseText.match(/```json\n([\s\S]*?)\n```/);
    if (jsonMatch) {
      const parsed = JSON.parse(jsonMatch[1]);
      if (parsed.suggestions && parsed.suggestions.length > 0) {
        displayCleanupSuggestions(parsed.suggestions);
      } else {
        if (cleanupStatus) cleanupStatus.style.display = "block";
        if (cleanupStatusText) cleanupStatusText.textContent = "✓ No issues found! Your data is clean.";
        if (cleanupSuggestions) cleanupSuggestions.innerHTML = "";
        if (cleanupMessage) cleanupMessage.textContent = "Complete";
      }
    } else {
      throw new Error("Invalid response format");
    }
  } catch (err) {
    console.error("Error scanning data:", err);
    if (cleanupMessage) cleanupMessage.textContent = "Error";
    if (cleanupStatus) cleanupStatus.style.display = "block";
    if (cleanupStatusText) cleanupStatusText.textContent = `Error: ${err.message}`;
    alert("Error scanning data: " + err.message);
  } finally {
    if (scanDataBtn) scanDataBtn.disabled = false;
  }
}

function displayCleanupSuggestions(suggestions) {
  const cleanupSuggestions = document.getElementById("cleanupSuggestions");
  const cleanupStatus = document.getElementById("cleanupStatus");
  const cleanupStatusText = document.getElementById("cleanupStatusText");
  const cleanupMessage = document.getElementById("cleanupMessage");

  if (!cleanupSuggestions) return;

  // Store suggestions globally for later retrieval
  storedCleanupSuggestions = suggestions;

  // Show status
  if (cleanupStatus) cleanupStatus.style.display = "block";
  if (cleanupStatusText) cleanupStatusText.textContent = `Found ${suggestions.length} issue${suggestions.length !== 1 ? 's' : ''} to fix.`;

  // Build suggestion cards
  const html = suggestions.map((s, idx) => `
    <div style="padding: 1rem; background: var(--bg-secondary); border: 1px solid var(--border); border-radius: 0.375rem; margin-bottom: 0.75rem;">
      <div style="font-size: 0.875rem; color: var(--text-secondary); margin-bottom: 0.5rem;">
        ${s.type === 'session' ? '📝 Session note' : s.type === 'job' ? '📅 Job text' : '📋 Project note'}
      </div>
      <div style="margin-bottom: 0.5rem;">
        <div style="font-size: 0.875rem; color: var(--text-secondary);">Current:</div>
        <div style="padding: 0.5rem; background: var(--bg); border-left: 3px solid #ef4444; font-size: 0.875rem; margin-bottom: 0.5rem;">"${s.current}"</div>
      </div>
      <div style="margin-bottom: 0.5rem;">
        <div style="font-size: 0.875rem; color: var(--text-secondary);">Improved:</div>
        <div style="padding: 0.5rem; background: var(--bg); border-left: 3px solid #10b981; font-size: 0.875rem; margin-bottom: 0.5rem;">"${s.improved}"</div>
      </div>
      <div style="font-size: 0.875rem; color: var(--text-secondary); margin-bottom: 0.75rem;">
        Reason: ${s.reason}
      </div>
      <label style="display: flex; align-items: center; gap: 0.5rem; cursor: pointer;">
        <input type="checkbox" class="cleanup-suggestion" data-index="${idx}" checked style="width: 1rem; height: 1rem; cursor: pointer;">
        <span style="font-size: 0.875rem;">Apply this fix</span>
      </label>
    </div>
  `).join('');

  cleanupSuggestions.innerHTML = html + `
    <div class="actions-row" style="margin-top: 1rem;">
      <button class="btn btn-primary" onclick="applyStoredCleanupSuggestions()">Apply Selected Fixes</button>
      <button class="btn btn-secondary" onclick="clearCleanupUI()">Cancel</button>
    </div>
  `;

  if (cleanupMessage) cleanupMessage.textContent = "Ready to apply";
}

function applyStoredCleanupSuggestions() {
  const cleanupSuggestions = document.getElementById("cleanupSuggestions");
  if (!cleanupSuggestions) return;

  const checkboxes = cleanupSuggestions.querySelectorAll(".cleanup-suggestion:checked");
  
  const suggestionsToApply = [];
  checkboxes.forEach((cb) => {
    const idx = parseInt(cb.getAttribute("data-index"));
    if (storedCleanupSuggestions && storedCleanupSuggestions[idx]) {
      suggestionsToApply.push(storedCleanupSuggestions[idx]);
    }
  });

  if (suggestionsToApply.length === 0) {
    alert("No suggestions selected.");
    return;
  }

  applyCleanup(suggestionsToApply);
}

async function applyCleanup(suggestions) {
  const cleanupMessage = document.getElementById("cleanupMessage");
  if (cleanupMessage) cleanupMessage.textContent = "Applying...";

  try {
    const res = await fetchWithAuth("/api/apply-cleanup", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ suggestions }),
    });

    if (!res.ok) throw new Error("Failed to apply cleanup");
    const result = await res.json();

    const successCount = suggestions.length;
    alert(`✓ Applied ${successCount} fix${successCount !== 1 ? 'es' : ''}!\n\nYour data has been cleaned up.`);

    clearCleanupUI();
    if (cleanupMessage) cleanupMessage.textContent = "Complete";
  } catch (err) {
    console.error("Error applying cleanup:", err);
    if (cleanupMessage) cleanupMessage.textContent = "Error";
    alert("Error applying cleanup: " + err.message);
  }
}

function clearCleanupUI() {
  const cleanupSuggestions = document.getElementById("cleanupSuggestions");
  const cleanupStatus = document.getElementById("cleanupStatus");
  if (cleanupSuggestions) cleanupSuggestions.innerHTML = "";
  if (cleanupStatus) cleanupStatus.style.display = "none";
  storedCleanupSuggestions = [];
}
